export function Soon({ title, text }: { title: string; text: string }) {
  return (
    <div className="stack">
      <header className="header">
        <h1 className="h1">{title}</h1>
      </header>
      <div className="card center" style={{ minHeight: 240 }}>
        <span className="h2">Скоро</span>
        <p className="muted" style={{ maxWidth: 300 }}>
          {text}
        </p>
      </div>
    </div>
  );
}
